"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRGBAToHex = exports.calcHex = exports.calcAlphaShade = exports.blend = exports.changeAlpha = void 0;
function changeAlpha(rgba, alpha) {
    return rgba.replace(/^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/, "rgba($1,$2,$3,".concat(alpha, ")"));
}
exports.changeAlpha = changeAlpha;
// возвращает цвет получаемый наложением двух других цветов
function blend(targetRgbaColor, overlayRgbaColor) {
    var match1 = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(targetRgbaColor);
    var match2 = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(overlayRgbaColor);
    if (!(match1 === null || match1 === void 0 ? void 0 : match1.length) || !(match2 === null || match2 === void 0 ? void 0 : match2.length)) {
        return targetRgbaColor;
    }
    var _a = __read(match1.map(Number), 5), r1 = _a[1], g1 = _a[2], b1 = _a[3], a1 = _a[4];
    var _b = __read(match2.map(Number), 5), r2 = _b[1], g2 = _b[2], b2 = _b[3], a2 = _b[4];
    var a = (1 - a2) * a1 + a2;
    var r = Math.floor(((1 - a2) * a1 * r1 + a2 * r2) / a);
    var g = Math.floor(((1 - a2) * a1 * g1 + a2 * g2) / a);
    var b = Math.floor(((1 - a2) * a1 * b1 + a2 * b2) / a);
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
}
exports.blend = blend;
var calcAlphaShade = function (colorRGBA, alpha) {
    return +(colorRGBA * alpha + 255 * (1 - alpha)).toFixed(0);
};
exports.calcAlphaShade = calcAlphaShade;
var calcHex = function (color) { return ('0' + color.toString(16)).slice(-2); };
exports.calcHex = calcHex;
var convertRGBAToHex = function (color) {
    var match = /^rgba[(]\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*[)]$/.exec(color);
    if (!match) {
        return;
    }
    var _a = __read(match.slice(1).map(Number), 4), r = _a[0], g = _a[1], b = _a[2], a = _a[3];
    var res = [r, g, b].map(function (c) { return (0, exports.calcHex)((0, exports.calcAlphaShade)(c, a)); });
    return "#".concat(res.join(''));
};
exports.convertRGBAToHex = convertRGBAToHex;
